const _ = require('lodash');

export default {

  defaultOrFirstId(list, currentId, useCurrentIdIfValid) {
    if (list.length === 0) {
      return '';
    }
    if (useCurrentIdIfValid) {
      return _.filter(list, { id: currentId }).length ? currentId : list[0].id;
    }
    return list[0].id;
  },

  defaultOrFirstIdLP(
    list, currentId, useCurrentIdIfValid,
    isInitialPageLoad, isVisualizationChanged,
  ) {
    if (list.length === 0) {
      return '';
    }
    if (useCurrentIdIfValid || isVisualizationChanged || isInitialPageLoad) {
      return _.filter(list, { id: currentId }).length ? currentId : list[0].id;
    }
    return list[0].id;
  },

  addSelectOne(list, obj) {
    const newObj = obj || { id: '', name: 'Select one', abbr: 'Select one' };
    list.splice(0, 0, newObj);
    return list;
  },


  validateTableIdsExistInLookups(lku, table, tableColumn, lookupType, errors) {
    _(table).map(tableColumn).uniq()
      .compact() // remove undefined due to nulls in optional columns
      .forEach((id) => {
        if (lku[lookupType][id] === undefined) {
          errors.push(`Missing lookup for id: "${id}", type: "${lookupType}" `);
        } else if (lookupType === 'Stratification') {
          const { parent } = lku[lookupType][id];
          if (parent === undefined) {
            errors.push(`Missing parent in lookup for id: "${id}", type: "${lookupType}" `);
          } else if (lku.StratificationCategory[parent] === undefined) {
            errors.push(`Missing lookup for id: "${parent}", type: "StratificationCategory" `);
          }
        }
      });
  },

  validateTableIdsExistInDataTypes(lku, table, tableColumn, lookupType, errors) {
    _(table).map(tableColumn).uniq()
      .compact() // remove undefined due to nulls in optional columns
      .forEach((id) => {
        if (lku[id] === undefined) {
          errors.push(`Missing dataTypes row for id: "${id}", type: "${lookupType}" `);
        }
      });
  },

  validateFootnoteSymbolExistsInFootnotes(footnotes, table, tableColumn, errors) {
    _(table).map(tableColumn).uniq()
      .compact() // remove undefined due to nulls in optional columns
      .forEach((sym) => {
        if (_(footnotes).find({ fs: sym, type: 'Footnote' }) === undefined) {
          errors.push(`Footnote symbol: '${sym}' missing from footnotes table with type: 'Footnote'`);
        }
      });
  },

  validateIdsExistInTable(ids, table, idColumn, idType, tableName, errors) {
    // const idsInTable = _(table).map(idColumn).uniq().value();
    _(ids).forEach((id) => {
      if (_(table).find(o => o[idColumn] === id) === undefined) {
        errors.push(`${tableName} is missing rows for ${idType}: ${id}`);
      }
    });
  },

  checkForMissingLookupTypes(lku) {
    // const start = performance.now();
    const missingTypes = [];
    const expectedTypes = [
      'Category',
      'DataSource',
      'DataValueType',
      'Location',
      'Question',
      'Response',
      'Stratification',
      'StratificationCategory',
      'Year',
    ];
    expectedTypes.forEach((type) => {
      if (_.size(lku[type]) === 0) {
        missingTypes.push(`Lookups is missing rows for type: ${type}`);
      }
    });
    // console.log('checkForMissingLookupTypes time: ', performance.now() - start);
    return missingTypes;
  },

  checkForMissingLookupIdsInSPGSLink(lku, link) {
    // const start = performance.now();
    const missingIds = [];
    this.validateTableIdsExistInLookups(lku, link, 'l', 'Location', missingIds);
    this.validateTableIdsExistInLookups(lku, link, 'c', 'Category', missingIds);
    this.validateTableIdsExistInLookups(lku, link, 'q', 'Question', missingIds);
    // console.log('checkForMissingLookupIdsInDSLink time: ', performance.now() - start);
    return missingIds;
  },

  checkForMissingLookupIdsInLPGSLink(lku, link) {
    // const start = performance.now();
    const missingIds = [];
    this.validateTableIdsExistInLookups(lku, link, 'c', 'Category', missingIds);
    this.validateTableIdsExistInLookups(lku, link, 'q', 'Question', missingIds);
    this.validateTableIdsExistInLookups(lku, link, 'mry', 'Year', missingIds);
    // console.log('checkForMissingLookupIdsInDSLink time: ', performance.now() - start);
    return missingIds;
  },

  checkForMissingLookupIdsFromRawSPData(lku, dataTypes, indicatorIds, data) {
    // const start = performance.now();
    const missingIds = [];
    this.validateTableIdsExistInLookups(lku, data, 'qi', 'Question', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'yr', 'Year', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 's1', 'Stratification', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 's2', 'Stratification', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'rs', 'Response', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'dvt', 'DataValueType', missingIds);
    this.validateTableIdsExistInDataTypes(dataTypes, data, 'dvt', 'DataValueType', missingIds);
    this.validateIdsExistInTable(indicatorIds, data, 'qi', 'indicatorId', 'spData', missingIds);
    // console.log('checkForMissingLookupIdsInIndicatorAllIds time: ', performance.now() - start);
    return missingIds;
  },

  checkForMissingLookupIdsFromRawQuestionData(lku, dataTypes, data) {
    // const start = performance.now();
    const missingIds = [];
    this.validateTableIdsExistInLookups(lku, data, 'yr', 'Year', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 's1', 'Stratification', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'dvt', 'DataValueType', missingIds);
    this.validateTableIdsExistInDataTypes(dataTypes, data, 'dvt', 'DataValueType', missingIds);
    // console.log('checkForMissingLookupIdsInIndicatorAllIds time: ', performance.now() - start);
    return missingIds;
  },

  checkForMissingLookupIdsInLPData(lku, lpData) {
    // const start = performance.now();
    const missingIds = [];
    // just check location since others should already be validated due
    // to previous indicatorAllIds check
    this.validateTableIdsExistInLookups(lku, lpData, 'loc', 'Location', missingIds);
    // console.log('checkForMissingLookupIdsInReportDataIds time: ', performance.now() - start);
    return missingIds;
  },

  checkForMissingLookupIdsInCRData(lku, dataTypes, footnotes, data) {
    // const start = performance.now();
    const missingIds = [];
    this.validateTableIdsExistInLookups(lku, data, 'c', 'Category', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'q', 'Question', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'r', 'Response', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 's1', 'Stratification', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 's2', 'Stratification', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'y', 'Year', missingIds);
    this.validateTableIdsExistInLookups(lku, data, 'dvt', 'DataValueType', missingIds);
    this.validateTableIdsExistInDataTypes(dataTypes, data, 'dvt', 'DataValueType', missingIds);
    this.validateFootnoteSymbolExistsInFootnotes(footnotes, data, 'fs', missingIds);
    // console.log('checkForMissingLookupIdsInCRData time: ', performance.now() - start);
    return missingIds;
  },

  checkForDuplicateSPDataRows(data) {
    const duplicateRowErrors = [];
    _(data).groupBy(r => `,${r.qi},${r.yr},${r.s1},${r.s2 ? r.s2 : ''},${r.rs},${r.dvt}`)
      .forEach((val, key) => {
        if (val.length > 1) {
          duplicateRowErrors.push(`Duplicate key error - found ${val.length} rows for Id's: ${key}.`);
        }
      });
    return duplicateRowErrors;
  },

  checkForDuplicateCRDataRows(data) {
    const duplicateRowErrors = [];
    _(data).groupBy(r => `${r.c},${r.q},${r.y},${r.s1},${r.s2 ? r.s2 : ''},${r.r},${r.l}`)
      .forEach((val, key) => {
        if (val.length > 1) {
          duplicateRowErrors.push(`Duplicate key error - found ${val.length} rows for Id's: ${key}.`);
        }
      });
    return duplicateRowErrors;
  },

  checkForMissingDataGuideRowInFootnotes(footnotes) {
    // Check that the RelatedLink row with footnote text 'Data Guide' exists
    // this row is used to display the Data Guide URL in the SP and LP link bucket
    const missing = [];
    if (_(footnotes).find({ type: 'RelatedLinks', ft: 'Data Guide' }) === undefined) {
      missing.push('Missing RelatedLink footnote row for Data Guide');
    }
    return missing;
  },

  addStratCatColumns(spData, lku) {
    return _(spData).map((o) => {
      const stratCatCols = { sc1: lku.Stratification[o.s1].parent };
      if (o.s2) {
        _.assign(stratCatCols, { sc2: lku.Stratification[o.s2].parent });
      }
      return _.assign(_.clone(o), stratCatCols);
    }).value();
  },

  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["o"] }] */
  addMultistratRowsAndStratCatColumns(spData, lku) {
    const level1rows = _(spData).filter(o => !o.s2)
      .map((o) => {
        // '1' means level 1 row
        o.multistrat = '1';
        return o;
      }).value();
    const level2rows12 = _(spData).filter(o => o.s2)
      .map((o) => {
        // '12' means level 2 row with strats in original order
        o.multistrat = '12';
        return o;
      }).value();
    const level2rows21 = _(level2rows12)
      .map((o) => {
        const { s1, s2 } = o;
        return _.assign(_.clone(o), {
          s1: s2,
          s2: s1,
          // '21' means level 2 row with strats in reverse order
          multistrat: '21',
        });
      }).value();
    const combinedRows = level1rows.concat(level2rows12).concat(level2rows21);
    const combinedRowsWithStratCatColumns = this.addStratCatColumns(combinedRows, lku);

    return _(combinedRowsWithStratCatColumns).orderBy(['qi', 'yr', 'sc1', 's1', 'sc2', 's2', 'rs', 'dvt']).value();
  },

  convertRelativeUrlToWCMSUrl(url) {
    // leave absolute url as is
    if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) return url;
    // assume this is a relative WCMS URL, prepend the base URL from the config file
    return process.env.WCMSBaseUrl + url;
  },

};




// WEBPACK FOOTER //
// ./src/helper.js